import '../App.css';
import ProductGallery from '../pages/ProductGallery'
import ProductList from '../pages/ProductList'




export default function MyProducts () {
	return (
		<>
		 <ProductGallery/> 
		 <ProductList/>
		</>

	)
}

